import React, { useContext } from "react";
import PropTypes from "prop-types";
//
import Tooltip from "@mui/material/Tooltip";
import { StoreContext } from "../../../../../store/StoreProvider";
import FullScreen from "../../../../components/FullScreen/FullScreen";
import IconFullscreen from "../../../../../../images/icon_fullscreen_dark/Mask Group 86.svg";
// eslint-disable-next-line import/no-cycle
import { SNA_DISPLAY_DIV_ID } from "../../../config";

const IconButtonWrapper = ({ children }) => (
  <Tooltip title="全螢幕模式" placement="left">
    {children}
  </Tooltip>
);

IconButtonWrapper.propTypes = {
  children: PropTypes.node,
};

IconButtonWrapper.defaultProps = {
  children: null,
};

const FullScreenIconTool = () => {
  const [_, dispatch] = useContext(StoreContext);

  const fullScreenEle = document.getElementById(SNA_DISPLAY_DIV_ID);
  const onFullScreen = () => {};
  const onExitFullScreen = () => {};

  return (
    <FullScreen
      fullScreenEle={fullScreenEle}
      onFullScreen={onFullScreen}
      onExitFullScreen={onExitFullScreen}
      iconButtonStyle={{
        "&.MuiIconButton-root": {
          backgroundColor: "#e6e9ef",
          boxShadow: "",
        },
      }}
      IconButtonWrapper={IconButtonWrapper}
      iconSrc={IconFullscreen}
      iconAlt="icon fullscreen"
      variant="square"
      toolTipTitle="全螢幕"
      tooltipPlacement="left"
    />
  );
};

export default FullScreenIconTool;
